import { PAGERDUTY_INTEGRATION_KEY, PAGERDUTY_SERVICE_ID } from './constants.esm.js';

function getPagerDutyEntity(entity) {
  const {
    [PAGERDUTY_INTEGRATION_KEY]: integrationKey,
    [PAGERDUTY_SERVICE_ID]: serviceId
  } = entity.metadata.annotations || {};
  const name = entity.metadata.name;
  return { integrationKey, serviceId, name };
}

export { getPagerDutyEntity };
//# sourceMappingURL=pagerDutyEntity.esm.js.map
